import { render, staticRenderFns } from "./ProjectContent.vue?vue&type=template&id=31ae75c9&"
import script from "./ProjectContent.vue?vue&type=script&lang=js&"
export * from "./ProjectContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports